import React from "react";
import Seo from "@/components/Seo";
import Icon from "@/components/Icon";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import LongForm from "@/components/LongForm";
import { SEO_CONTENT } from "@/data/seoContent";
import { WHY } from "@/data/site";

export default function Pourquoi() {
  return (
    <>
      <Seo
        title="Pourquoi Choisir FuiteX pour votre Recherche de Fuite ?"
        description="Localisation précise, intervention rapide, matériel professionnel, compte-rendu détaillé : découvrez ce qui distingue FuiteX en Île-de-France."
        canonical="/pourquoi-fuitex"
      />
      <PageHero
        overline="Pourquoi FuiteX"
        titleLines={["Pourquoi choisir", "FuiteX ?"]}
        subtitle="Face à une fuite, vous cherchez un partenaire fiable, rapide et transparent. Voici ce qui fait la différence."
        breadcrumb={[{ label: "Pourquoi FuiteX" }]}
      />

      <section className="bg-white py-24">
        <div className="container-x grid gap-6 md:grid-cols-12">
          {WHY.map((w, i) => (
            <Reveal
              key={w.title}
              delay={i * 0.06}
              className={`relative rounded-3xl border border-ink/10 p-8 overflow-hidden ${
                i === 0 ? "md:col-span-7 bg-ink" : i === 1 ? "md:col-span-5 bg-mist" : "md:col-span-4 bg-mist"
              }`}
            >
              <span className={`absolute right-6 top-4 text-7xl font-black select-none ${i === 0 ? "text-white/5" : "text-aqua/10"}`}>
                0{i + 1}
              </span>
              <div className={`flex h-12 w-12 items-center justify-center rounded-2xl ${i === 0 ? "bg-aqua text-white" : "bg-aqua/10 text-aqua"}`}>
                <Icon name={w.icon} size={24} />
              </div>
              <h2 className={`mt-6 text-xl font-bold ${i === 0 ? "text-white" : "text-ink"}`}>{w.title}</h2>
              <p className={`mt-3 leading-relaxed ${i === 0 ? "text-white/70" : "text-ink/65"}`}>{w.text}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-mist py-24">
        <div className="container-x">
          <LongForm data={SEO_CONTENT.pourquoi} />
        </div>
      </section>

      <CTASection title="Faites confiance à un spécialiste de la fuite non destructive." />
    </>
  );
}
